$(document).ready(function(){
    if ($('.section-awards-program .tab-con').length > 0) {
        $(".section-awards-program .tab-con").mCustomScrollbar({
            scrollInertia: 0,
            callbacks: {
                onScrollStart: function(){
                    $(this).addClass('shadow-top');
                    $(this).addClass('shadow-bottom');
                },
                onTotalScroll: function() {
                    $(this).removeClass('shadow-bottom');
                },
                onTotalScrollBack: function() {
                    $(this).removeClass('shadow-top');
                },
                onTotalScrollBackOffset: 80,
                onTotalScrollOffset: 80
            }
        });
    }

    $('.tabs li').on('click', function() {
        $('.tabs li').removeClass('active');
        $(this).addClass('active');
        $('.tab-con').removeClass('active');

        var index = $(this).index() + 1;

        $('.tab-con:nth-of-type(' + index + ')').addClass('active');
    });

    var tiltSettings = {
        movement: {
            imgWrapper : {
                translation : {x: 0, y: -8, z: 0},
                rotation : {x: 3, y: 3, z: 0},
                reverseAnimation : {duration : 1200, easing : 'easeOutExpo'}
            },
            lines : {
                translation : {x: 15, y: 15, z: [0,15]},
                reverseAnimation : {duration : 1200, easing : 'easeOutExpo'}
            },
            overlay : {
                translation : {x: 0, y: 8, z: 0},
                reverseAnimation : {duration : 600, easing : 'easeOutExpo'}
            },
            caption : {
                translation : {x: 10, y: -15, z: 0},
                reverseAnimation : {duration : 900, easing : 'easeOutExpo'}
            },
            shine : {
                translation : {x: 50, y: 50, z: 0},
                reverseAnimation : {duration : 1200, easing : 'easeOutExpo'}
            }
        }
    };

    [].slice.call(document.querySelectorAll('.tilter')).forEach(function(el, pos) {
        new TiltFx(el, tiltSettings);
    });

    $('.owl-carousel').owlCarousel({
        margin: 20,
        nav: true,
        responsive : {
            0 : {
                items: 1
            },
            599 : {
                items: 2
            },
            992 : {
                items: 3
            }
        }
    });

    $(".fancybox").fancybox({
        padding: 0
    });

    if ($(this).scrollTop() > 0) {
        $('.header').addClass('fixed');
    } else {
        $('.header').removeClass('fixed');
    }

    $('.hero-modal').on('click', function () {
        var which = $(this).data('open');
        $('.modal-' + which).addClass('active');
        $('body').addClass('fixed');
    });

    $('.select').select2({
        placeholder: " ",
        minimumResultsForSearch: Infinity
    });

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    // Application form logic

    $('.first-step-next').on('click', function () {
        var validatable = $('.form-step-1 .validatable');

        validatable.each(function () {
            $(this).removeClass('not-valid');
            var value = $(this).val();

            if ($(this).attr("id") == "email") {
                if (!validateEmail(value)) {
                    $(this).addClass('not-valid');
                }
            } else {
                if (value == "") {
                    $(this).addClass('not-valid');
                }
            }
        });

        if (!validatable.hasClass('not-valid')) {
            $('.form-step-1').removeClass('active');
            $('.form-step-2').addClass('active');
            $('.step-tab-1').removeClass('active');
            $('.step-tab-2').addClass('active');

            $('html, body').animate({
                scrollTop: $(".section-application").offset().top
            }, 500);
        }
    });

    $('.second-step-prev').on('click', function () {
        $('.form-step-2').removeClass('active');
        $('.form-step-1').addClass('active');
        $('.step-tab-2').removeClass('active');
        $('.step-tab-1').addClass('active');
    });

    $('.third-step-prev').on('click', function () {
        $('.form-step-3').removeClass('active');
        $('.form-step-2').addClass('active');
        $('.step-tab-3').removeClass('active');
        $('.step-tab-2').addClass('active');
    });

    $('.second-step-next').on('click', function () {
        var validatable = $('.form-step-2 .validatable');

        validatable.each(function () {
            $(this).removeClass('not-valid');
            $(this).next().removeClass('not-valid');
            var value = $(this).val();

            if (value == "") {
                $(this).addClass('not-valid');

                if ($(this).hasClass('select')) {
                    $(this).next().addClass('not-valid');
                }
            }
        });

        if (!validatable.hasClass('not-valid')) {
            $('.form-step-2').removeClass('active');
            $('.form-step-3').addClass('active');
            $('.step-tab-2').removeClass('active');
            $('.step-tab-3').addClass('active');

            $('html, body').animate({
                scrollTop: $(".section-application").offset().top
            }, 500);
        }
    });

    var fileInputCount = 1;
    var activeFileInputCount = 0;
    var filePlaceholder = $('.file-input-wrap input').prev( 'label' ).find('span').html();

    function addFileInput() {
        var nextIndex = +fileInputCount + +1;
        fileInputCount = nextIndex;
        var fileInputEl = '' +
            '<div class="input-wrap file-input-wrap">' +
                '<label for="files' + nextIndex + '" class="fileslabel">' +
                    '<img src="' + window.wp.template_url + '/assets/images/file-icon.png" alt="File">' +
                    '<span>' + filePlaceholder + '</span>' +
                '</label>' +
                '<input type="file" id="files' + nextIndex + '" name="file' + nextIndex + '" class="file-input">' +
            '</div>';

        $('.file-inputs').append(fileInputEl);
    }

    $('body').on( 'change', 'input[type=file]', function( e ) {
        var $input	 = $(this),
            $label	 = $input.prev( 'label' );

        var fileName = '';

        if( this.files && this.files.length > 1 )
            fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
        else if( e.target.value )
            fileName = e.target.value.split( '\\' ).pop();

        if( fileName ) {
            activeFileInputCount = +activeFileInputCount + +1;
            if (!($label.find( 'span' ).hasClass('active')) && (activeFileInputCount == fileInputCount)) {
                addFileInput();
            }
            $label.find( 'span' ).html( fileName ).addClass('active');
        } else {
            $label.find('span').html( filePlaceholder ).removeClass('active');
            activeFileInputCount = +activeFileInputCount - +1;
        }
    });

    $('.form-submit').on('click', function (e) {
        var validatable = $('.form-step-3 .validatable');

        validatable.each(function () {
            $(this).removeClass('not-valid');
            $(this).prev().removeClass('not-valid');
            var value = $(this).val();

            if (value == "") {
                $(this).addClass('not-valid');
                $(this).prev().addClass('not-valid');
            }
        });

        // if (activeFileInputCount == 0) {
        //     $('.file-input').prev().addClass('not-valid')
        // } else {
        //     $('.file-input').prev().removeClass('not-valid')
        // }

        // if (!validatable.hasClass('not-valid') && (activeFileInputCount > 0)) {
        if (!validatable.hasClass('not-valid')) {

        } else {
            e.preventDefault();
        }
    });

    $('.menu-trigger, .header-ovrl').on('click', function () {
        $('.menu-trigger').toggleClass('active');
        $('.menu').toggleClass('active');
        $('.header-ovrl').toggleClass('active');
        $('body').toggleClass('active');
    });
});

$(window).on('scroll', function(){
    if ($(this).scrollTop() > 0) {
        $('.header').addClass('fixed');
    } else {
        $('.header').removeClass('fixed');
    }
});

$(window).on('resize', function(){

});